import { c as _c } from "react/compiler-runtime";
import { Box, Fieldset, Stack } from '@chakra-ui/react';
import { ReactNode } from 'react';

/** Two-column settings block: title + description, then controls. */
export const SettingsFormSection = t0 => {
  const $ = _c(18);
  const {
    id,
    title,
    description,
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "column",
      lg: "row"
    };
    t2 = {
      base: 4,
      lg: 8
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      lg: "0 0 14rem"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <Fieldset.Legend fontWeight="semibold" textStyle="lg">{title}</Fieldset.Legend>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description) {
    t5 = description ? <Fieldset.HelperText>{description}</Fieldset.HelperText> : null;
    $[5] = description;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Stack flex={t3} gap={1} minW={0}>{t4}{t5}</Stack>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== children) {
    t7 = <Fieldset.Content alignItems="stretch" flex="1" gap={6} maxW="4xl" minW={0}>{children}</Fieldset.Content>;
    $[10] = children;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <Fieldset.Root flexDir={t1} gap={t2} size="lg">{t6}{t7}</Fieldset.Root>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== id || $[16] !== t8) {
    t9 = <Box id={id} scrollMarginTop={8}>{t8}</Box>;
    $[15] = id;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};